import { pangaeaV1API } from "../api/pangaeaV1API";

export const {
  useGetDesignProfilesQuery,
  useCreateDesignProfileMutation,
  useUpdateDesignProfileMutation,
  useUpdateProfileMutation,
} = pangaeaV1API;
